import { render, staticRenderFns } from "./JxmBenefit.vue?vue&type=template&id=7cb45257&scoped=true&"
import script from "./JxmBenefit.vue?vue&type=script&lang=js&"
export * from "./JxmBenefit.vue?vue&type=script&lang=js&"
import style0 from "./JxmBenefit.vue?vue&type=style&index=0&id=7cb45257&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb45257",
  null
  
)

export default component.exports